import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { Clinic } from '../models/clinic.model';
import { ClinicService } from '../services/clinic.service';

export const ClinicResolver: ResolveFn<Clinic> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  clinicService = inject(ClinicService),
): Observable<Clinic> => clinicService.findBySlug(route.paramMap.get('clinicSlug'));
